import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { ToastMessageService } from '../shared/common-components/lms-toast-messages/service/toast-message.service';
import { GlobalConstants } from '../shared/global-constants';
import { UserAuthoritiesService } from '../shared/user/user-authorities.service';

const AUTHORIZATION_HEADER = 'Authorization';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly toastMessageService: ToastMessageService,
    private readonly userAuthoritiesService: UserAuthoritiesService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.endsWith('get_token')) {
      return next.handle(req);
    }

    if (
      !req.url.includes('/notes/device/') &&
      !req.url.includes('/images/device/') &&
      !req.url.includes('get_tenant_basic_profile')
    ) {
      const token = localStorage.getItem('token');
      if (token) {
        req = req.clone({ headers: req.headers.set(AUTHORIZATION_HEADER, token) });
      }
      req = req.clone({
        withCredentials: false,
      });
    }

    if (req.url.includes('get_tenant_basic_profile')) {
      req = req.clone({
        headers: req.headers.set('operation', 'get_tenant_basic_profile'),
      });
    }

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        const logoutUrl = `${window.location.origin}/assets/logout.html`;
        if (err.error ? err.error.code === 'UM408' : false) {
          const toastErrorMesage = {
            severity: GlobalConstants.ERROR_LOWERCASE,
            summary: err.error.code,
            detail: 'Forbidden or permission denied',
            key: 'access',
            closable: false,
          };
          this.toastMessageService.showError(toastErrorMesage);
          this.userAuthoritiesService.clearCache();
          localStorage.clear();
          window.open(logoutUrl, '_self');
        } else if (err.status === 401 || err.status === 403) {
          this.onErrorOrEmptyToken();
        }

        return throwError(err);
      })
    );
  }

  private onErrorOrEmptyToken = () => {
    const logoutUrl = `${window.location.origin}/assets/logout.html`;
    this.userAuthoritiesService.clearCache();
    localStorage.clear();
    localStorage.setItem(
      GlobalConstants.REDIRECT_URL,
      environment.redirectUrl
    );
    window.open(logoutUrl, '_self');
  }
}
